module.exports = __webpack_public_path__ + "img/astral_13.efd2467c.svg";